
import { computed, defineComponent } from 'vue';
import useConfig from '@/composables/useConfig';
import { useToast } from "vue-toastification";
import features, { Feature, FeatureMeasurability } from '@/composables/useConfig/features';

export default defineComponent({

	setup() {

		const config = useConfig()
		const toast = useToast()

		const enabled_features= computed(() => config.features?.filter(x => x.enabled));

		return {
			config,
			toast, 

			enabled_features
		}

	}

});
